import { Icon, Toggle, TooltipHost } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAttr } from '../../../../../features/helpers/apiHelpers';

const MetaDataSwitches = ({
  updateHearingModelAttribute,
  hearingModel,
  hearingModelIsCreatedStatus,
}) => {
  const { t: translator } = useTranslation();

  const publishComments = getAttr(hearingModel, 'showComments');
  const autoApproveComments = getAttr(hearingModel, 'autoApproveComments');

  const onChangePublishComments = (_, value) => {
    updateHearingModelAttribute('showComments', value);
  };

  const onChangeAutoApproveComments = (_, value) => {
    updateHearingModelAttribute('autoApproveComments', value);
  };

  const publishCommentsLabel = (
    <div id="agora-app-hearing-switch">
      {translator('pages.createHearing.publishComments')}{' '}
      <TooltipHost
        content={translator('pages.createHearing.publishCommentsTooltip')}
      >
        <Icon iconName="Info" />
      </TooltipHost>
    </div>
  );

  const autoApproveCommentsLabel = (
    <div id="agora-app-hearing-switch">
      {translator('pages.createHearing.autoApproveComments')}{' '}
      <TooltipHost
        content={translator('pages.createHearing.autoApproveCommentsTooltip')}
      >
        <Icon iconName="Info" />
      </TooltipHost>
    </div>
  );

  return (
    <div className="create-hearing-switches">
      <Toggle
        label={publishCommentsLabel}
        onText={translator('global.yes')}
        offText={translator('global.no')}
        checked={publishComments}
        onChange={onChangePublishComments}
        disabled={!hearingModelIsCreatedStatus}
      />
      <Toggle
        label={autoApproveCommentsLabel}
        onText={translator('global.yes')}
        offText={translator('global.no')}
        checked={autoApproveComments}
        onChange={onChangeAutoApproveComments}
        disabled={!hearingModelIsCreatedStatus}
      />
    </div>
  );
};

export { MetaDataSwitches };
